export function generateCodeUtm(tamanho = 5) {
  const caracteres = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let codigo = '';

  for (let i = 0; i < tamanho; i++) {
    const indice = Math.floor(Math.random() * caracteres.length);
    codigo += caracteres[indice];
  }

  return codigo;
}